export const dataTypes = {
  DEBT: 'DEBT', // Qarzdorliklar
  LEAD: 'LEAD' // Lidlar
};

export const fieldValues = {
  CURRENCY: 'CURRENCY', // select with API
  HOUSE: 'HOUSE', // select with API // subIds
  PIPE: 'PIPE', // select with API // subIds
  EMPLOYEE: 'EMPLOYEE', // select with API
  DEBT_AMOUNT: 'DEBT_AMOUNT', // input number
  SURCHARGE: 'SURCHARGE', // input number
  DELAY: 'DELAY', // input number
  MAX_DELAY: 'MAX_DELAY', // input number
  DATE: 'DATE', // datepicker,
  TAG: 'TAG' // select with API
};

export const fieldValuesWithDataType = {
  DEBT: ['CURRENCY', 'HOUSE', 'EMPLOYEE', 'DEBT_AMOUNT', 'SURCHARGE', 'DELAY', 'MAX_DELAY'],
  LEAD: ['PIPE', 'DATE', 'EMPLOYEE', 'TAG']
};

export const checkValues = {
  EQUAL: 'EQUAL', // input numbers and datepicker
  NOT_EQUAL: 'NOT_EQUAL', // input numbers and datepicker
  IN: 'IN', // all selects multiple
  NOT_IN: 'NOT_IN', // all selects multiple
  LESS_THAN: 'LESS_THAN', // input numbers and datepicker
  GREATER_THAN: 'GREATER_THAN', // input numbers and datepicker
  LESS_THAN_OR_EQUAL: 'LESS_THAN_OR_EQUAL', // input numbers and datepicker
  GREATER_THAN_OR_EQUAL: 'GREATER_THAN_OR_EQUAL' // input numbers and datepicker
};

export const checkValuesWithField = {
  CURRENCY: ['IN', 'NOT_IN'],
  HOUSE: ['IN', 'NOT_IN'],
  PIPE: ['IN', 'NOT_IN'],
  EMPLOYEE: ['IN', 'NOT_IN'],
  DEBT_AMOUNT: ['EQUAL', 'NOT_EQUAL', 'LESS_THAN', 'GREATER_THAN', 'LESS_THAN_OR_EQUAL', 'GREATER_THAN_OR_EQUAL'],
  SURCHARGE: ['EQUAL', 'NOT_EQUAL', 'LESS_THAN', 'GREATER_THAN', 'LESS_THAN_OR_EQUAL', 'GREATER_THAN_OR_EQUAL'],
  DELAY: ['EQUAL', 'NOT_EQUAL', 'LESS_THAN', 'GREATER_THAN', 'LESS_THAN_OR_EQUAL', 'GREATER_THAN_OR_EQUAL'],
  MAX_DELAY: ['EQUAL', 'NOT_EQUAL', 'LESS_THAN', 'GREATER_THAN', 'LESS_THAN_OR_EQUAL', 'GREATER_THAN_OR_EQUAL'],
  DATE: ['EQUAL', 'NOT_EQUAL', 'LESS_THAN', 'GREATER_THAN', 'LESS_THAN_OR_EQUAL', 'GREATER_THAN_OR_EQUAL'],
  TAG: ['IN', 'NOT_IN']
};

export const queryValuesWithFields = {
  multiSelect: ['CURRENCY', 'HOUSE', 'PIPE', 'EMPLOYEE', 'TAG'],
  input: ['DEBT_AMOUNT', 'SURCHARGE', 'DELAY', 'MAX_DELAY'],
  datepicker: ['DATE']
} as const;

export const automationTypeValues = {
  NOW: 'NOW',
  SCHEDULE: 'SCHEDULE',
  EVERY_DAY: 'EVERY_DAY',
  CUSTOM_DAILY: 'CUSTOM_DAILY',
  CUSTOM_WEEKLY: 'CUSTOM_WEEKLY'
};

export const collectionClassNames = {
  input: 'h-11 rounded-lg px-3.5 py-2.5',
  label: 'text-sm font-medium text-gray-700',
  multiSelect:
    'flex-1 [&_.ant-select-selection-search]:!flex [&_.ant-select-selector]:!h-11 [&_.ant-select-selection-search]:!items-center [&_.ant-select-selector]:!flex [&_.ant-select-selector]:!items-center [&_.ant-select-selector]:!rounded-lg [&_.ant-select-selector]:!px-3.5 [&_.ant-select-selection-item]:!m-0  [&_.ant-select-selection-item]:box-border [&_.ant-select-selection-item]:!h-full [&_.ant-select-selection-item]:rounded-md [&_.ant-select-selection-overflow]:!flex [&_.ant-select-selection-overflow]:!h-full [&_.ant-select-selection-overflow]:!items-center [&_.ant-select-selection-overflow]:!gap-1 [&_.ant-select-selector]:!items-center',
  select:
    '[&_.ant-select-selection-search]:!flex [&_.ant-select-selection-search]:!items-center [&_.ant-select-selector]:!flex [&_.ant-select-selector]:!h-11 [&_.ant-select-selector]:!items-center [&_.ant-select-selector]:!rounded-lg [&_.ant-select-selector]:!px-3.5',
  date: '!h-11 rounded-lg [&_.ant-picker-clear]:flex [&_.ant-picker-clear]:h-6  [&_.ant-picker-clear]:w-6 [&_.ant-picker-clear]:items-center [&_.ant-picker-clear]:justify-center'
};

export const dayOfWeekValues = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'] as const;
